export const isAdditiveLayerSelect = (event) =>
  Boolean(event?.shiftKey || event?.ctrlKey || event?.metaKey);

export const preventNativeTextSelectOnAdditivePointer = (event) => {
  if (!isAdditiveLayerSelect(event)) return;
  event.preventDefault();
  window.getSelection?.()?.removeAllRanges?.();
};

export const preventLayerListNativeSelectStart = (event) => {
  if (event.target?.closest?.("input, textarea, [contenteditable='true']")) {
    return;
  }
  event.preventDefault();
};

export const layerListNoNativeSelectSx = {
  userSelect: "none",
  WebkitUserSelect: "none",
};

export const nextLayerSelection = ({
  currentIDs = [],
  id,
  event,
  preserveMulti = false,
}) => {
  if (!id) return { primary: null, ids: [] };
  const current = Array.isArray(currentIDs) ? currentIDs.filter(Boolean) : [];
  if (isAdditiveLayerSelect(event)) {
    const exists = current.includes(id);
    const ids = exists
      ? current.filter((item) => item !== id)
      : [...current, id];
    return {
      primary: exists ? ids[ids.length - 1] || null : id,
      ids,
    };
  }
  if (preserveMulti && current.includes(id) && current.length > 1) {
    return { primary: id, ids: current };
  }
  return { primary: id, ids: [id] };
};

export const nextMarqueeSelection = ({ currentIDs = [], ids = [], event }) => {
  const incoming = (Array.isArray(ids) ? ids : []).filter(Boolean);
  if (isAdditiveLayerSelect(event)) {
    const merged = [...currentIDs];
    incoming.forEach((id) => {
      if (!merged.includes(id)) merged.push(id);
    });
    return {
      primary:
        incoming[incoming.length - 1] || merged[merged.length - 1] || null,
      ids: merged,
    };
  }
  return {
    primary: incoming[incoming.length - 1] || null,
    ids: incoming,
  };
};

/**
 * Ids a copy or delete should touch.
 * An explicit id expands to the whole selection only when that selection
 * already has several ids and includes it. Otherwise the explicit id wins.
 * With no explicit id, the current selection wins, then the fallback.
 * `expandsSelection` is the multi-select / hotkey case. Callers that protect
 * the background keep that check themselves.
 */
export const resolveOperationIds = ({
  explicitID,
  selectedIDs = [],
  fallbackID,
} = {}) => {
  const selected = Array.isArray(selectedIDs) ? selectedIDs : [];
  const expandsSelection =
    selected.length > 1 && (!explicitID || selected.includes(explicitID));
  const requested = explicitID
    ? expandsSelection
      ? selected
      : [explicitID]
    : selected.length > 0
      ? selected
      : [fallbackID];
  return {
    ids: [...new Set(requested.filter(Boolean))],
    expandsSelection,
  };
};

export const getLiveMarqueeSelection = ({
  committedIDs = [],
  committedPrimary = null,
  hitIds = [],
  additive = false,
  active = false,
}) => {
  if (!active) {
    return { ids: committedIDs, primary: committedPrimary };
  }
  return nextMarqueeSelection({
    currentIDs: committedIDs,
    ids: hitIds,
    event: additive ? { shiftKey: true } : undefined,
  });
};
